export default __webpack_public_path__ + "static/media/app-bar-logo.393e0974.svg";